import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SvgIcon from 'li-components/lib/SvgIcon'
import vars from 'li-components/lib/styles'

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 1.5rem 1rem;
  margin: 1rem;
  border: 2px solid ${vars.brandInfo};
  font-size: 16px;

  .SvgIcon {
    margin-right: 1.5rem;
    margin-left: 0.5rem;
  }

  svg {
    fill: ${vars.brandInfo};
  }
`

const Info = ({ children, ...rest }) => (
  <Container {...rest}>
    <SvgIcon name="info-2" />
    {children}
  </Container>
)

Info.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Info



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Info.js